module.exports = __webpack_public_path__ + "static/img/setting2.69ccbf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/setting2.png
// module id = eFA1
// module chunks = 24